<template>
  <div class="modal-container">
    <Dialog :visible="display" :modal="true" :style="{ width: isMD ? '98vw' : '70vw' }">
      <template #header>
        <h1 class="title pm-txt-color">Discharge request</h1>
      </template>
      <Spinner v-if="isLoadingPage" class="flex" />
      <div v-else class="modal-content">
        <img width="40" src="@/assets/discharge.svg" />
        <div class="discharge-details mt-3 bold-600">Discharge request details</div>
        <p class="desc pm-txt-color mt-2 bold-600">
          I/We would like to commence the discharge process to repay my/our loan account for the property(s) below:
        </p>
        <!-- <p class="desc pm-txt-color bold-600" style="margin-bottom: -10px">
          Estimated payout date
        </p>
        <DatePicker
          @change="getFormData($event, 'estimated_payout_date')"
          width="100%"
          style="width: 100%"
          placeholder="DD/MM/YYYY"
        /> -->

        <div class="section-1 mt-3 p-3">
          <div class="details-content mb-2">The loan will be repaid by way of</div>
          <SingleCheckbox
            @getInputValue="(e) => (showPurchaseProperties = e)"
            label="The property is sold"
            id="The property is sold"
            :value="showPurchaseProperties"
            @click="changePurchaseProperties"
          />
          <SingleCheckbox
            @getInputValue="(e) => (showLoanRefinancing = e)"
            label="The loan is to be refinanced"
            id="The loan is to be refinanced"
            :value="showLoanRefinancing"
            @click="changeLoanRefinancing"
          />
          <SingleCheckbox
            @getInputValue="(e) => (showCashPayment = e)"
            label="The loan will be paid with cash"
            id="The loan will be paid with cash"
            :value="showCashPayment"
            @click="changeCashPayment"
          />
        </div>

        <div v-if="showPurchaseProperties">
          <div v-if="showPurchaseProperties" class="section-1 mt-3 p-3">
            <div class="details-content mb-2">Properties for Sale</div>
            <div :class="isMD ? '' : 'flex'">
              <!-- <div class="col">
                <div class="details-content-subtitle mb-2">
                  Purchase Properties
                </div>
                <div v-if="buyingDetails && buyingDetails.length">
                  <div v-for="(item, i) in buyingDetails" :key="i">
                    <SingleCheckbox
                      :value="item.selected"
                      @click="changePurchaseProperties"
                      @getInputValue="(e) => (item.selected = e)"
                      :label="`${item.line1} ${item.city} ${item.state}
                ${item.country} ${item.postCode}`"
                      :id="`${item.line1}
                ${item.city} ${item.state} ${item.country} ${item.postCode}`"
                    />
                  </div>
                </div>
              </div> -->
              <div class="col">
                <!-- <div class="details-content-subtitle mb-2">
                  Properties for Sale
                </div> -->
                <div v-for="(item, i) in sellingDetails" :key="i">
                  <SingleCheckbox
                    :value="item.selected"
                    @click="changePurchaseProperties"
                    @getInputValue="(e) => (item.selected = e)"
                    :label="`${item.line1} ${item.city} ${item.state}
                ${item.country} ${item.postCode}`"
                    :id="`${item.line1}
                ${item.city} ${item.state} ${item.country} ${item.postCode}`"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- <div v-for="(item, i) in buyingDetails" :key="i">
            <div v-if="item.selected" class="section-1 mt-3 p-3">
              <div v-if="item.selected" class="details-content mb-2">
                {{
                  `${item.line1} ${item.city} ${item.state}
                ${item.country} ${item.postCode}`
                }}
              </div>
              <div v-if="item.selected" :class="isMD ? '' : 'flex'">
                <div class="col">
                  <div :class="isMD ? '' : 'flex'">
                    <InputWithIcon
                      class="col"
                      label="Sales price"
                      placeholder="Enter amount"
                      :format="true"
                      :icon="dollar"
                      @onInput="getBuyingDetails($event, 'purchasePrice', i)"
                      type="number"
                    />
                    <InputWithIcon
                      class="col"
                      :class="isMD ? '' : 'ml-2'"
                      label="Valuation price"
                      placeholder="Enter amount"
                      :format="true"
                      :icon="dollar"
                      type="number"
                      @onInput="getBuyingDetails($event, 'valuationPrice', i)"
                    />
                  </div>
                  <div class="mt-4" :class="isMD ? '' : 'flex'">
                    <div class="col">
                      <p class="settlement-date">Settlement Date</p>
                      <DatePicker
                        @change="getBuyingDetails($event, 'settlementDate', i)"
                        placeholder="DD/MM/YYYY"
                        :minDate="new Date()"
                        yearRange="2022:2122"
                      />
                    </div>
                    <div class="col ml-2"></div>
                  </div>
                </div>
                <div class="col" :class="isMD ? 'mt-4' : 'ml-4'">
                  <FileUpload
                    @files="getBuyingDetails($event, 'files', i)"
                    title="Copy of the contract of sale"
                    :id="`Copy of the contract of sale-buying${i}`"
                  />
                </div>
              </div>
            </div>
          </div> -->
          <div v-for="(item, i) in sellingDetails" :key="i">
            <div v-if="item.selected" class="section-1 mt-3 p-3">
              <div v-if="item.selected" class="details-content mb-2">
                {{
                  `${item.line1} ${item.city} ${item.state}
                ${item.country} ${item.postCode}`
                }}
              </div>
              <div v-if="item.selected" :class="isMD ? '' : 'flex'">
                <div class="col">
                  <div :class="isMD ? '' : 'flex'">
                    <InputWithIcon
                      class="col"
                      label="Sales price"
                      placeholder="Enter amount"
                      :format="true"
                      :icon="dollar"
                      @onInput="getSellingDetails($event, 'purchasePrice', i)"
                      type="number"
                    />
                    <InputWithIcon
                      class="col"
                      :class="isMD ? 'mt-4' : 'ml-2'"
                      label="Valuation price"
                      placeholder="Enter amount"
                      :format="true"
                      :icon="dollar"
                      type="number"
                      @onInput="getSellingDetails($event, 'valuationPrice', i)"
                    />
                  </div>
                  <div class="mt-4" :class="isMD ? '' : 'flex'">
                    <div class="col">
                      <p class="settlement-date">Settlement Date</p>
                      <DatePicker
                        @change="getSellingDetails($event, 'settlementDate', i)"
                        placeholder="DD/MM/YYYY"
                        :minDate="new Date()"
                        yearRange="2022:2122"
                      />
                    </div>
                    <div class="col ml-2"></div>
                  </div>
                </div>
                <div class="col" :class="isMD ? 'mt-4' : 'ml-4'">
                  <FileUpload
                    @files="getSellingDetails($event, 'files', i)"
                    title="Copy of the contract of sale"
                    :id="`Copy of the contract of sale-selling${i}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showLoanRefinancing" class="section-1 mt-3 p-3">
          <div class="details-content mb-2">Loan Refinancing</div>
          <div :class="isMD ? '' : 'flex'">
            <div class="col">
              <div class="flex">
                <InputWithIcon
                  class="col"
                  :class="isMD ? '' : 'col-6'"
                  label="Amount to be refinanced"
                  placeholder="Enter amount"
                  :format="true"
                  :icon="dollar"
                  type="number"
                  @onInput="getLoanRefinace($event ? $event : Number($event), 'loanRefinancingAmount')"
                />
              </div>
              <div class="flex mt-4">
                <div class="col" :class="isMD ? '' : 'col-6'">
                  <p class="settlement-date">Date of refinancing</p>
                  <DatePicker
                    @change="getLoanRefinace($event, 'loanRefinancingDate')"
                    placeholder="DD/MM/YYYY"
                    :minDate="new Date()"
                    yearRange="2022:2122"
                  />
                </div>
              </div>
            </div>
            <div class="col" :class="isMD ? 'mt-4' : 'ml-4'">
              <FileUpload
                @files="getLoanRefinace($event, 'loanRefinancingFiles')"
                title="Copy of conditional approval of sale"
                id="Copy of conditional approval of sale"
              />
            </div>
          </div>
        </div>

        <div v-if="showCashPayment" class="section-1 mt-3 p-3">
          <div class="details-content mb-2">Cash Repayment</div>
          <div :class="isMD ? '' : 'flex'">
            <div>
              <div class="col">
                <div class="flex">
                  <InputWithIcon
                    type="number"
                    class="col"
                    :class="isMD ? '' : 'col-6'"
                    label="Amount to be repaid"
                    placeholder="Enter amount"
                    :format="true"
                    :icon="dollar"
                    @onInput="getCashPayment($event, 'cashRepaymentAmount')"
                  />
                </div>
              </div>
              <div class="flex mt-4">
                <div class="col" :class="isMD ? '' : 'col-6'">
                  <p class="settlement-date">Date of refinancing</p>
                  <DatePicker
                    @change="getCashPayment($event, 'cashRepaymentDate')"
                    placeholder="DD/MM/YYYY"
                    :minDate="new Date()"
                    yearRange="2022:2122"
                  />
                </div>
              </div>
            </div>
            <div class="col" :class="isMD ? 'mt-4' : 'ml-4'">
              <FileUpload
                @files="getCashPayment($event, 'cashRepaymentFiles')"
                title="Bank Statement confirming Cash Funds"
                id="Bank Statement confirming Cash Funds"
              />
            </div>
          </div>
        </div>

        <div>
          <div class="details-content-subtitle mt-3 mb-2">Solicitor/conveyancer details</div>
          <div :class="isMD ? '' : 'flex'" :key="formDataKey">
            <TextField
              @onInput="getSolicitorData($event, 'solicitorFirstName')"
              class="col"
              width="100%"
              :value="formData.solicitorFirstName"
              label="First name"
            />
            <TextField
              @onInput="getSolicitorData($event, 'solicitorLastName')"
              class="col"
              width="100%"
              label="Last name"
              :class="isMD ? 'mt-2' : 'ml-2'"
              :value="formData.solicitorLastName"
            />
            <TextField
              @onInput="getSolicitorData($event, 'solicitorEmail')"
              class="col"
              width="100%"
              label="Email"
              :class="isMD ? 'mt-2' : 'ml-2'"
              :value="formData.solicitorEmail"
            />
          </div>
          <div class="mt-2" :class="isMD ? '' : 'flex'">
            <TextField
              @onInput="getSolicitorData($event ? $event.toString() : '', 'solicitorPhone')"
              class="col"
              width="100%"
              label="Phone"
              type="number"
              :value="formData.solicitorPhone"
            />
            <TextField
              @onInput="getSolicitorData($event, 'solicitorCompany')"
              class="col"
              width="100%"
              label="Company"
              :class="isMD ? 'mt-2' : 'ml-2'"
              :value="formData.solicitorCompany"
            />
            <TextField
              @onInput="getSolicitorData($event, 'solicitorAddress')"
              class="col"
              width="100%"
              label="Address"
              :class="isMD ? 'mt-2' : 'ml-2'"
              :value="formData.solicitorAddress"
            />
          </div>
        </div>

        <div class="acknowledgement mt-3">
          I/We acknowledge the following conditions: <br />
          • The loan repayments are due in full until the day discharge is complete; <br />
          • That on settlement a release of Mortgage so far as the land is concerned will be given but I/we shall not be
          released from the personal covenants of the Mortgage until audit of the account is completed. Any necessary
          adjustments of a refund will be forwarded to me/us via post.
          <br />
          • I/we similarly understand that if the audit shows further monies are due I/we shall be asked to pay them.
          <br />
          • TechLend’s Solicitor requires five (5) days notice for booking of the discharge settlement.
        </div>

        <div>
          <div class="details-content-subtitle mt-3 mb-2">Applicant 1 signature</div>
          <div :class="isMD ? '' : 'flex'">
            <TextField
              class="col"
              :disable="true"
              width="100%"
              label="First name"
              :value="formData.applicantFirstName"
            />
            <TextField
              :disable="true"
              class="col"
              :class="isMD ? '' : 'ml-2'"
              width="100%"
              label="Last name"
              :value="formData.applicantLastName"
            />
          </div>
          <div class="p-float-label label hk-grotest-medium mt-4">Draw your signature with your mouse or touch.</div>
          <div class="signature-container mt-2">
            <VueSignaturePad
              :customStyle="{
                background: 'white',
                border: '1px solid #02003826',
                borderRadius: '4px',
              }"
              height="200px"
              ref="signaturePad"
              :options="{ onBegin, onEnd }"
            />
            <div class="clear">
              <span @click="clearSignature">Clear</span>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="modal-foodter">
          <Button :disabled="isSubmitDisabled() || isLoading" label="Submit request" type="primary" @click="saveData" />
          <p class="close" @click="closeDialog">Close</p>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { email, helpers, integer, maxLength, minLength, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Dialog from 'primevue/dialog';
import Dollar from '@/assets/dollar.svg';
import FileUpload from '../FileUploadComponent.vue';
// import { checkMobileNumber } from "../../../../../services/validatePhNo";
import { API } from '@/constants.api';
import { TECHLEND_BE_URL } from '@/constants.api';
import { _post } from '@/services/crudService';
import { convertFiletoBase64 } from '@/services/FileConverttoBase64';
import { mapActions, mapGetters } from 'vuex';
import Screensize from '@/mixins/screensize.mixin';

export default {
  props: ['display', 'openDialog', 'closeDialog', 'change'],
  mixins: [Screensize],
  components: { Dialog, FileUpload },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      formDataKey: 10,
      imgsrc: '',
      dollar: Dollar,
      showPurchaseProperties: false,
      showLoanRefinancing: false,
      showCashPayment: false,
      formData: {
        // estimated_payout_date: "",
        repaidBy: [],
        purchase_properties: [],
        selling_properties: [],
        loanRefinancingAmount: '',
        loanRefinancingDate: '',
        loanRefinancingFiles: [],
        cashRepaymentAmount: '',
        cashRepaymentDate: '',
        cashRepaymentFiles: [],
        cash_repayment_date: '',
        solicitorFirstName: '',
        solicitorLastName: '',
        solicitorEmail: '',
        solicitorPhone: '',
        solicitorCompany: '',
        solicitorAddress: '',
        applicantFirstName: '',
        applicantLastName: '',
        applicantSignature: '',
        applicant_type: '',
      },
      buyingDetails: [],
      sellingDetails: [],
      isLoading: false,
      isLoadingPage: true,
    };
  },
  validations() {
    // let buyingDetails = this.buyingDetails.map((data) => {
    //   if (data.selected === true) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });
    let sellingDetails = this.sellingDetails.map((data) => {
      if (data.selected === true) {
        return true;
      } else {
        return false;
      }
    });
    if (
      this.showCashPayment &&
      this.showLoanRefinancing &&
      this.showPurchaseProperties &&
      // buyingDetails[0] === true &&
      sellingDetails[0] === true
    ) {
      return {
        formData: {
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (
      this.showCashPayment &&
      this.showPurchaseProperties &&
      // buyingDetails[0] === true &&
      sellingDetails[0] === true
    ) {
      return {
        formData: {
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (
      this.showLoanRefinancing &&
      this.showPurchaseProperties &&
      // buyingDetails[0] === true &&
      sellingDetails[0] === true
    ) {
      return {
        formData: {
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (
      this.showPurchaseProperties &&
      // buyingDetails[0] === true &&
      sellingDetails[0] === true
    ) {
      return {
        formData: {
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (
      this.showLoanRefinancing &&
      this.showPurchaseProperties
      // buyingDetails[0] === true
    ) {
      return {
        formData: {
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (this.showLoanRefinancing && this.showPurchaseProperties && sellingDetails[0] === true) {
      return {
        formData: {
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (
      this.showCashPayment &&
      this.showPurchaseProperties
      // buyingDetails[0] === true
    ) {
      return {
        formData: {
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (this.showCashPayment && this.showPurchaseProperties && sellingDetails[0] === true) {
      return {
        formData: {
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (this.showLoanRefinancing && this.showCashPayment) {
      return {
        formData: {
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
        },
      };
    } else if (this.showPurchaseProperties) {
      return {
        formData: {
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          purchase_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (this.showPurchaseProperties && sellingDetails[0] === true) {
      return {
        formData: {
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
          selling_properties: {
            $each: helpers.forEach({
              purchasePrice: { required },
              valuationPrice: { required },
              settlementDate: { required },
              files: { required },
            }),
          },
        },
      };
    } else if (this.showLoanRefinancing) {
      return {
        formData: {
          loanRefinancingAmount: { required },
          loanRefinancingDate: { required },
          loanRefinancingFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
        },
      };
    } else if (this.showCashPayment) {
      return {
        formData: {
          cashRepaymentAmount: { required },
          cashRepaymentDate: { required },
          cashRepaymentFiles: { required },
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
        },
      };
    } else {
      return {
        formData: {
          // estimated_payout_date: { required },
          solicitorFirstName: { required },
          solicitorLastName: { required },
          solicitorEmail: { required, email },
          solicitorPhone: {
            required,
            integer,
            maxLength: maxLength(10),
            minLength: minLength(10),
          },
          solicitorCompany: { required },
          solicitorAddress: { required },
          applicantSignature: { required },
        },
      };
    }
  },
  methods: {
    ...mapActions({
      getSolictorDetailsById: 'applications/getSolictorDetailsById',
    }),
    isSubmitDisabled() {
      return this.v$.$invalid;
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.imgsrc = '';
    },
    async onEnd() {
      // isEmpty,
      this.formData.applicantSignature = 'success';
      const { data } = this.$refs.signaturePad.saveSignature();
      const url = data.replace('data:', '').replace(/^.+,/, '');
      await _post(TECHLEND_BE_URL + 'brokers/file-uploads/' + this.applicationId, {
        fileName: 'signature.png',
        type: 'customer',
        applicationId: this.applicationId,
        isSupporting: true,
        document: url,
        documentType: 'supporting_document',
        taskId: this.selectedTaskId,
      });
    },
    getFormData(value, fieldName) {
      this.formData[fieldName] = value;
      this.formData = { ...this.formData };
    },
    async getLoanRefinace(value, fieldName) {
      if (fieldName === 'loanRefinancingFiles') {
        this.formData[fieldName] = [];
        value.map(async (obj) => {
          const url = await convertFiletoBase64(obj);
          await _post(TECHLEND_BE_URL + 'brokers/file-uploads/' + this.applicationId, {
            fileName: 'Conditional approval of sale',
            type: 'customer',
            applicationId: this.applicationId,
            isSupporting: true,
            document: url,
            documentType: 'buying property',
            taskId: this.selectedTaskId,
          });
          this.formData[fieldName].push(obj.name);
        });
        return;
      }
      this.formData[fieldName] = value;
      this.formData = { ...this.formData };
    },
    async getCashPayment(value, fieldName) {
      if (fieldName === 'cashRepaymentFiles') {
        this.formData[fieldName] = [];
        value.map(async (obj) => {
          let url = await convertFiletoBase64(obj);
          await _post(TECHLEND_BE_URL + 'brokers/file-uploads/' + this.applicationId, {
            fileName: 'Bank statement confirming cash funds',
            type: 'customer',
            applicationId: this.applicationId,
            isSupporting: true,
            document: url,
            documentType: 'supporting_document',
            taskId: this.selectedTaskId,
          });
          this.formData[fieldName].push(obj.name);
        });
        return;
      }
      this.formData[fieldName] = value;
      this.formData = { ...this.formData };
    },
    getSolicitorData(value, fieldName) {
      this.formData[fieldName] = value;
      this.formData = { ...this.formData };
    },
    async getBuyingDetails(value, fieldName, index) {
      if (fieldName === 'files') {
        this.formData.purchase_properties[index][fieldName] = [];
        value.map(async (obj) => {
          let url = await convertFiletoBase64(obj);
          await _post(TECHLEND_BE_URL + 'brokers/file-uploads/' + this.applicationId, {
            fileName: obj.name,
            type: 'customer',
            applicationId: this.applicationId,
            isSupporting: true,
            document: url,
            documentType: 'supporting_document',
            taskId: this.selectedTaskId,
          });
          this.formData.purchase_properties[index][fieldName].push(obj.name);
        });
        return;
      } else this.formData.purchase_properties[index][fieldName] = value;
    },
    async getSellingDetails(value, fieldName, index) {
      if (fieldName === 'files') {
        this.formData.selling_properties[index][fieldName] = [];
        const address = this.sellingDetails[index];
        value.map(async (obj) => {
          let url = await convertFiletoBase64(obj);
          await _post(TECHLEND_BE_URL + 'brokers/file-uploads/' + this.applicationId, {
            fileName:
              'Contract for sale:' +
              address.line1 +
              ',' +
              address.city +
              ',' +
              address.state +
              ',' +
              address.country +
              ',' +
              address.postCode,
            type: 'customer',
            applicationId: this.applicationId,
            isSupporting: true,
            document: url,
            documentType: 'supporting_document',
            taskId: this.selectedTaskId,
          });
          this.formData.selling_properties[index][fieldName].push(obj.name);
        });
        return;
      } else this.formData.selling_properties[index][fieldName] = value;
    },
    async saveData() {
      try {
        this.isLoading = true;
        this.formData.repaidBy = [];
        this.formData.applicantFirstName = this.selectedApplication.applicants[0].firstName;
        this.formData.applicantLastName = this.selectedApplication.applicants[0].lastName;
        if (this.showPurchaseProperties) {
          this.formData.repaidBy.push('the property is sold');
        } else {
          this.formData.purchase_properties = [];
          this.formData.selling_properties = [];
        }
        if (this.showLoanRefinancing) {
          this.formData.repaidBy.push('the l0an is to be refinanced');
        } else {
          this.formData.loanRefinancingAmount = 0;
        }
        if (this.showCashPayment) {
          this.formData.repaidBy.push('the loan will be paid with cash');
        } else {
          this.formData.cashRepaymentAmount = 0;
        }
        this.formData = {
          ...this.formData,
          applicationId: this.applicationId,
        };
        const payload = this.formData;
        await _post(TECHLEND_BE_URL + API.SUBMIT_DISCHARGE_REQUEST, payload);

        this.$emit('completed');
        this.isLoading = false;
      } catch (err) {
        await this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Something went wrong',
          life: 3000,
        });
        this.isLoading = false;
      }
    },
    changePurchaseProperties() {
      // let buyingDetails = this.buyingDetails.map((data) => {
      //   if (data.selected === true) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // });
      let sellingDetails = this.sellingDetails.map((data) => {
        if (data.selected === true) {
          return true;
        } else {
          return false;
        }
      });
      if (!this.showPurchaseProperties) {
        this.formData.purchase_properties = [
          {
            settlementDate: '',
            valuationPrice: 0,
            purchasePrice: 0,
            files: [],
          },
        ];
        this.formData.selling_properties = [
          {
            settlementDate: '',
            valuationPrice: 0,
            purchasePrice: 0,
            files: [],
          },
        ];
      }
      // if (buyingDetails[0] === false) {
      //   this.formData.purchase_properties = [
      //     {
      //       settlementDate: "",
      //       valuationPrice: 0,
      //       purchasePrice: 0,
      //       files: [],
      //     },
      //   ];
      // }
      if (sellingDetails[0] === false) {
        this.formData.selling_properties = [
          {
            settlementDate: '',
            valuationPrice: 0,
            purchasePrice: 0,
            files: [],
          },
        ];
      }
    },
    changeLoanRefinancing() {
      if (!this.showLoanRefinancing) {
        this.formData.loanRefinancingAmount = 0;
        this.formData.loanRefinancingDate = '';
        this.formData.loanRefinancingFiles = [];
      }
    },
    changeCashPayment() {
      if (!this.showCashPayment) {
        this.formData.cashRepaymentAmount = 0;
        this.formData.cashRepaymentDate = '';
        this.formData.cashRepaymentFiles = [];
      }
    },
  },
  computed: {
    ...mapGetters('applications', ['selectedApplication', 'applicationId', 'selectedTaskId']),
  },
  async created() {
    this.isLoadingPage = true;
    // if (
    //   this.selectedApplication &&
    //   this.selectedApplication.incomingProperties
    // ) {
    //   this.buyingDetails = this.selectedApplication.incomingProperties.map(
    //     (obj) => {
    //       this.formData.purchase_properties.push({
    //         property_id: obj.Id,
    //         property: "incoming",
    //         line1: obj.line1,
    //         line2: obj.line2,
    //         valuationPrice: 0,
    //         purchasePrice: 0,
    //         files: [],
    //       });
    //       return {
    //         ...obj,
    //         selected: true,
    //       };
    //     }
    //   );
    // }
    if (this.selectedApplication && this.selectedApplication.outgoingProperties) {
      this.sellingDetails = this.selectedApplication.outgoingProperties.map((obj) => {
        this.formData.selling_properties.push({
          property_id: obj.Id,
          property: 'outgoing',
          line1: obj.line1,
          line2: obj.line2,
          valuationPrice: 0,
          purchasePrice: 0,
          files: [],
        });
        return {
          ...obj,
          selected: true,
        };
      });
    }
    const result = await this.getSolictorDetailsById();
    if (result && result.data && result.data && result.data.length && result.data[0].firstName) {
      const obj = result.data[0];
      this.formData.solicitorFirstName = obj.firstName;
      this.formData.solicitorLastName = obj.lastName;
      this.formData.solicitorEmail = obj.email;
      this.formData.solicitorPhone = obj.mobilePhoneNumber;
      this.formData.solicitorCompany = obj.company;
      this.formData.solicitorAddress = obj.address;
      this.formDataKey += 1;
    }
    this.isLoadingPage = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.container {
  font-family: HK-medium;
}
.title {
  font-weight: bold;
  color: $primary-color;
  font-size: 2.25rem;
}

.desc {
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  line-height: 1.7;
}

.text {
  margin-bottom: 0.3rem;
}

.field-not {
  width: 100%;
}

.heading,
.text {
  font-size: 0.875rem !important;
}

.inputs {
  gap: 1rem;
  align-items: flex-end;
}

.modal-content {
  border: none;

  .section-1 {
    border: 1px solid rgba(2, 0, 56, 0.15);
    border-radius: 8px;

    .details-content {
      color: $secondary-color;
      font-weight: 600;
      font-size: 20px;
    }
    .details-content-subtitle {
      color: $secondary-color;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .section-2 {
    margin-top: 1.875rem;

    .label {
      margin-bottom: 1rem;
    }
  }

  .section-3 {
    margin-top: 1.875rem;
    width: 100%;

    .label {
      margin-bottom: 1rem;
    }

    .mail-total {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      margin-top: 1rem;
      gap: 1rem;
    }
  }

  .icon-wrapper {
    gap: 1rem;

    .icon {
      font-size: 2rem;
    }
  }

  .heading {
    margin: 0;
    font-weight: bold;
    font-size: 1.25rem;
  }
}
.modal-foodter {
  gap: 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .close {
    margin: 0;
    cursor: pointer;
  }
}
.discharge-details {
  color: $secondary-color;
  font-weight: 600;
  font-size: 16px;
}
.col {
  padding: unset !important;
}
.acknowledgement {
  font-weight: 500;
  color: rgba(2, 0, 56, 0.3);
  font-size: 14px;
}
.settlement-date {
  font-family: HK-medium !important;
}
.signature-container {
  position: relative;
  canvas {
    background: white !important;
  }
  .clear {
    font-weight: 600;
    font-size: 18px;
    color: #54b7f9;
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 20px;
    .save {
      color: green;
    }
  }
}
</style>
